import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import {
  authenticationExpiredEvent,
  authenticationGenerationStorageKey,
  clearAuthenticatedCache,
  listenForAuthenticationChanges,
} from "./authCache";
import { rememberPostLoginReturn } from "./postLoginReturn";
import { initializePwaInstall } from "./pwaInstall";
import "@fontsource-variable/plus-jakarta-sans";
import "./styles.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 20_000, retry: (count, error) => count < 1 && !(error instanceof Error && "status" in error && (error as { status: number }).status < 500) } } });

let clearingAuthentication = false;
function isolateAuthentication() {
  if (clearingAuthentication) return;
  clearingAuthentication = true;
  if (window.location.pathname === "/app/upload")
    rememberPostLoginReturn(window.location.href);
  void clearAuthenticatedCache(queryClient).finally(() => {
    if (window.location.pathname !== "/login") window.location.assign("/login");
    clearingAuthentication = false;
  });
}
window.addEventListener(authenticationExpiredEvent, isolateAuthentication);
window.addEventListener("storage", (event) => {
  if (event.key === authenticationGenerationStorageKey && event.newValue !== event.oldValue)
    isolateAuthentication();
});
listenForAuthenticationChanges(isolateAuthentication);
const mobilePwaInstall = initializePwaInstall();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.getRegistrations()
      .then(async (registrations) => {
        await Promise.all(
          registrations
            .filter((registration) => {
              const scopePath = new URL(registration.scope).pathname;
              return scopePath === "/" ||
                (!mobilePwaInstall && scopePath.startsWith("/app/upload"));
            })
            .map((registration) => registration.unregister()),
        );
        if (mobilePwaInstall)
          await navigator.serviceWorker.register("/service-worker.js", {
            scope: "/app/upload",
          });
      });
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><QueryClientProvider client={queryClient}><RouterProvider router={router} context={{ queryClient }} /></QueryClientProvider></React.StrictMode>);
